import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "vouchers-card"
};
const _hoisted_2 = {
    key: 0,
    class: "hero-banner"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "card-body" };
const _hoisted_5 = { class: "title-block" };
const _hoisted_6 = {
    key: 0,
    class: "description"
};
const _hoisted_7 = {
    key: 1,
    class: "subtitle"
};
const _hoisted_8 = {
    key: 0,
    class: "savings-pill"
};
const _hoisted_9 = { class: "savings-pill-icon" };
const _hoisted_10 = ["src"];
const _hoisted_11 = {
    key: 1,
    class: "stat-boxes"
};
const _hoisted_12 = {
    href: "/#/SavedToSpend",
    class: "stat-box stat-green"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = { class: "stat-value" };
const _hoisted_15 = {
    href: "/#/SavedToSpend",
    class: "stat-box stat-teal"
};
const _hoisted_16 = ["src"];
const _hoisted_17 = { class: "stat-value" };
const _hoisted_18 = {
    key: 2,
    class: "brand-row"
};
const _hoisted_19 = ["href"];
const _hoisted_20 = ["src"];
const _hoisted_21 = {
    key: 3,
    class: "footnote"
};
const _hoisted_22 = {
    key: 1,
    href: "/#/ShopVouchers",
    class: "bottom-banner banner-green"
};
const _hoisted_23 = { class: "bottom-banner-text" };
const _hoisted_24 = ["src"];
const _hoisted_25 = ["src"];
const _hoisted_26 = ["src"];
import { computed } from 'vue';
import { useAppState } from '@/composables/useAppState';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VouchersOverviewCard',
    props: {
        hasBankAccount: { type: Boolean },
        hasVouchers: { type: Boolean },
        savedLastMonth: {},
        allTimeSavings: {},
        savedToSpend: {},
        estimatedAnnualSavings: {},
        potentialSavings: {},
        brandItems: {}
    },
    emits: ["explore", "connect-accounts"],
    setup(__props) {
        const state = useAppState();
        const formatter = computed(() => state.formatter);
        return (_ctx, _cache) => {
            return (_ctx.brandItems && _ctx.brandItems.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (!_ctx.hasVouchers)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("img", {
                                src: require('@/assets/available_vouchers.png'),
                                class: "hero-image"
                            }, null, 8, _hoisted_3)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "Save on everyday spending", -1)),
                            (!_ctx.hasVouchers)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Get instant discounts at 100+ retailers — from groceries to days out. "))
                                : (_openBlock(), _createElementBlock("p", _hoisted_7, [
                                    _cache[2] || (_cache[2] = _createTextVNode(" You saved ")),
                                    _createElementVNode("strong", null, _toDisplayString(formatter.value.format(_ctx.savedLastMonth || 0)), 1),
                                    _cache[3] || (_cache[3] = _createTextVNode(" last month. "))
                                ]))
                        ]),
                        (!_ctx.hasBankAccount && !_ctx.hasVouchers && _ctx.estimatedAnnualSavings)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("img", {
                                        src: require('@/assets/icons/shopping-bag.png')
                                    }, null, 8, _hoisted_10)
                                ]),
                                _createElementVNode("span", null, "Members can save " + _toDisplayString(_ctx.estimatedAnnualSavings) + " a year*", 1)
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.hasVouchers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("a", _hoisted_12, [
                                    _createElementVNode("img", {
                                        src: require('@/assets/icons/shopping-bag.png'),
                                        class: "stat-icon"
                                    }, null, 8, _hoisted_13),
                                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "stat-label" }, "All time savings", -1)),
                                    _createElementVNode("div", _hoisted_14, _toDisplayString(formatter.value.format(_ctx.allTimeSavings || 0)), 1)
                                ]),
                                _createElementVNode("a", _hoisted_15, [
                                    _createElementVNode("img", {
                                        src: require('@/assets/icons/coins-swap.png'),
                                        class: "stat-icon"
                                    }, null, 8, _hoisted_16),
                                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "stat-label" }, "Saved to Spend", -1)),
                                    _createElementVNode("div", _hoisted_17, _toDisplayString(formatter.value.format(_ctx.savedToSpend || 0)), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.hasBankAccount || _ctx.hasVouchers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandItems, (item, i) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                        key: i,
                                        href: item.url,
                                        class: "brand-circle"
                                    }, [
                                        _createElementVNode("img", {
                                            src: item.img
                                        }, null, 8, _hoisted_20)
                                    ], 8, _hoisted_19));
                                }), 128))
                            ]))
                            : _createCommentVNode("", true),
                        _createVNode(MGButton, {
                            small: true,
                            leftAlign: true,
                            arrow: true,
                            noCaps: true,
                            text: _ctx.hasBankAccount ? 'Explore your discounts' : 'Explore all discounts',
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('explore')))
                        }, null, 8, ["text"]),
                        (!_ctx.hasBankAccount && !_ctx.hasVouchers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, " *Estimated savings based on average member spending and available discounts "))
                            : _createCommentVNode("", true)
                    ]),
                    (_ctx.hasBankAccount && !_ctx.hasVouchers && _ctx.potentialSavings)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_22, [
                            _createElementVNode("span", _hoisted_23, [
                                _cache[7] || (_cache[7] = _createTextVNode("You could have saved ")),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.potentialSavings), 1),
                                _cache[8] || (_cache[8] = _createTextVNode(" in the last 12 months based on your spending."))
                            ]),
                            _createElementVNode("img", {
                                src: require('@/assets/arrow-right.png'),
                                class: "bottom-banner-arrow"
                            }, null, 8, _hoisted_24)
                        ]))
                        : _createCommentVNode("", true),
                    (!_ctx.hasBankAccount && _ctx.hasVouchers)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            href: "#",
                            class: "bottom-banner banner-blue",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.$emit('connect-accounts')), ["prevent"]))
                        }, [
                            _createElementVNode("img", {
                                src: require('@/assets/linkto.png'),
                                class: "link-icon"
                            }, null, 8, _hoisted_25),
                            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "bottom-banner-text" }, "Connect your accounts to unlock personalised savings.", -1)),
                            _createElementVNode("img", {
                                src: require('@/assets/arrow-right.png'),
                                class: "bottom-banner-arrow"
                            }, null, 8, _hoisted_26)
                        ]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
